import { useEffect, useMemo } from 'react';
import CourtHeader from './CourtHeader';
import BookingButton from './BookingButton';
import moment from 'moment-timezone';
import { isTimeBetweenRange } from '../utils';
import { useBookingContext } from '../context';
import { isMobile } from 'react-device-detect';

export default ({ courtDetails, slider }) => {
  const { selectedDate, startTime, endTime, setPrice } = useBookingContext();
  const getHoursBetween = (start, end) => {
    return moment.duration(moment(end, 'HH:mm').diff(moment(start, 'HH:mm'))).asHours();
  };

  const cells = useMemo(() => {

    return new Array(getHoursBetween(courtDetails.startTime, courtDetails.endTime) * 2 + 1)
        .fill({ time: null })
        .map((_, index) => {
          const timeMoment = moment(courtDetails.startTime, 'HH:mm').add(30 * index, 'minutes');
          const time = timeMoment.format('HH:mm');

          let price = courtDetails.defaultPrice / 2;

          if (
              courtDetails.specialPrices[0] &&
              isTimeBetweenRange(
                  time,
                  courtDetails.specialPrices[0].startTime,
                  courtDetails.specialPrices[0].endTime,
                  '[)'
              )
          ) {
            price = courtDetails.specialPrices[0].price / 2;
          }

          const isToday = moment().isSame(moment(selectedDate), 'day')
          const isInThePast = timeMoment.isBefore(moment()
              .tz('Europe/Kyiv'), 'minute');

          let isFree = true;

          if (isInThePast && isToday) {
            isFree = false;
          } else if (courtDetails.bookings.length > 0) {
            const isBooked = courtDetails.bookings.some((booking) => {
              return isTimeBetweenRange(
                  time,
                  moment(booking.startTime, 'HH:mm').add(30, 'm').format('HH:mm'),
                  moment(booking.endTime, 'HH:mm').subtract(30, 'm').format('HH:mm')
              );
            });

            if (isBooked) {
              isFree = false;
            }
          }

          return {
            time,
            isFree,
            price,
            courtId: courtDetails._id,
            courtName: courtDetails.name
          };
        })
        .map((cell, index, arr) => {
          const left = index - 1 >= 0 ? arr[index - 1].isFree === false : false;
          const right = index + 1 < arr.length ? arr[index + 1].isFree === false : false;
          if (left && right) {
            return {
              ...cell,
              isFree: false
            };
          }
          return cell;
        });
  }, [courtDetails]);


  useEffect(() => {
    if (!startTime || !endTime) {
      setPrice(0);
    } else {
      const price = cells.reduce((acc, cell) => {
        if (isTimeBetweenRange(cell.time, startTime, endTime, '[)')) {
          return acc + cell.price;
        }
        return acc;
      }, 0);
      setPrice(price);
    }
  }, [startTime, endTime]);

  return (
    <div className="sm:pt-10 lg:pt-10 flex flex-wrap lg:basis-1/4 md:basis-1/2">
      <div className="flex flex-row items-center justify-space w-full px-4 mb-8">
        {isMobile && (
          <div className="flex" onClick={() => slider.slickPrev()}>
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" fill="none">
              <path d="M8.267 15 1.733 8l6.534-7" stroke="#fff" strokeWidth="2" />
            </svg>
          </div>
        )}
        <CourtHeader name={`Корт №${courtDetails.name}`} />
        {isMobile && (
          <div className="flex" onClick={() => slider.slickNext()}>
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" fill="none">
              <path d="m.733 1 6.534 7-6.534 7" stroke="#fff" strokeWidth="2" />
            </svg>
          </div>
        )}
      </div>
      <div className="flex flex-wrap w-full flex-row justify-center">
        {cells.map((cell, index) => {
          return (
            <BookingButton
              booking={cell}
              courtDetails={courtDetails}
              key={courtDetails._id + index + cell.time}
              cells={cells}
            />
          );
        })}
      </div>
    </div>
  );
};
